import React from 'react';
import { isMobile } from 'react-device-detect';
import { IBaseSrcAlt } from '../../../../../Interfaces/base';


interface DescriptionProp {
  icon: IBaseSrcAlt;
  title: string;
  subtitle: string;
  description: string[] | string;
  mobileSpecialDisplay?: boolean;
}

const Description = ({icon, title, subtitle, description, mobileSpecialDisplay}: DescriptionProp) => {

  const isSpecialDisplay = isMobile && mobileSpecialDisplay;
  const normalizedContent = Array.isArray(description) ? description.join(", ") : description;

  return (
    <div className='d-flex align-items-start'>
      {!isMobile && <img src={icon.src} alt={icon?.alt} className='services-icon'/>}
      <div className={!isMobile && 'ms-2'}>
        {!isMobile && <h4 className='mb-3'>{title}</h4>}
        {isSpecialDisplay && <div className='special-services-display'>
          <img src={icon.src} alt={icon?.alt} className='services-icon'/>
          <div className='ms-2'>
            <h4 className='mb-1'>{title}</h4>
            <div className='services-label'>Remote orders</div>
          </div>
        </div>}
        <div className='services-subtitle'>{subtitle}</div>
        <div className='services-description' dangerouslySetInnerHTML={{ __html: normalizedContent }} />
      </div>
    </div>
  )
}

export default Description;
